var publicPath = __webpack_public_path__;
                    module.exports = {
                        symbol: publicPath + 'sprite.svg#icon-top',
                        view: publicPath + 'sprite.svg#view-icon-top',
                        viewBox: '0 0 40 40',
                        title: 'icons/fonctions/top',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };